/**
Call mobile app api (aka "bridge")
Relying on presence of the api objects, no platform detection
*/

const MobileApi = {

  // must use global object
  getAndroidBridge() {
    if (typeof StoryJsInterface !== 'undefined') {
      // eslint-disable-next-line no-undef
      return StoryJsInterface;
    }
    return null;
  },

  getIosBridge() {
    if (typeof window === 'undefined') {
      return null;
    }
    const { webkit } = window;
    if (typeof webkit !== 'undefined') {
      return webkit;
    }
    return null;
  },

  trackPageView(message) {
    // Android
    const androidBridge = this.getAndroidBridge();
    if (androidBridge) {
      try {
        androidBridge.trackPageView(message);
        return 'android';
      } catch (e) {
        return e;
      }
    }

    // IOS
    const iosBridge = this.getIosBridge();
    if (iosBridge) {
      try {
        iosBridge.messageHandlers.trackPageView.postMessage(message);
        return 'ios';
      } catch (e) {
        return e;
      }
    }

    return null;
  },

  /**
   * View a short video.
   * @param {string} videoId - The ID of the video.
   * @param {string[]} packageVideoIds - An array of package video IDs.
   */
  viewShort(videoId, packageVideoIds) {
    // Android
    const androidBridge = this.getAndroidBridge();
    if (androidBridge) {
      try {
        androidBridge.viewShort(
          JSON.stringify({
            videoId,
            packageVideoIds,
          }),
        );
        return 'android';
      } catch (e) {
        return e;
      }
    }
    // IOS
    const iosBridge = this.getIosBridge();
    if (iosBridge) {
      try {
        iosBridge.messageHandlers.viewShort.postMessage(
          JSON.stringify({
            videoId,
            packageVideoIds,
          }),
        );
        return 'ios';
      } catch (e) {
        return e;
      }
    }
    return null;
  },

  viewVideo(message) {
    // Android
    const androidBridge = this.getAndroidBridge();
    if (androidBridge) {
      try {
        androidBridge.viewVideo(message);
        return 'android';
      } catch (e) {
        return e;
      }
    }

    // IOS
    const iosBridge = this.getIosBridge();
    if (iosBridge) {
      try {
        iosBridge.messageHandlers.viewVideo.postMessage(message);
        return 'ios';
      } catch (e) {
        return e;
      }
    }

    return null;
  },
  /**
   * Sets up a listener to receive PiP video status updates from the mobile app.
   *
   * @param {(videoStatus: {
   *   pipActive: boolean,
   *   pipPaused: boolean,
   *   pipMuted: boolean
   * }) => void} onVideoStatusChange - Callback function invoked with the latest video status.
   */
  getVideoStatus: (onVideoStatusChange) => {
    window.addEventListener('videoStatusChange', (event) => {
      const videoStatus = event?.detail?.videoStatus;
      if (videoStatus) {
        onVideoStatusChange(videoStatus);
      }
    });
  },
  /**
   * Request Omega web playback action from the mobile app.
   * @param {(playbackAction: string) => void} requestPlaybackAction - Callback function to request a playback action.
   */
  playbackAction: (requestPlaybackAction) => {
    window.addEventListener('requestPlaybackAction', (event) => {
      const playbackAction = event?.detail?.playbackAction;
      if (playbackAction) {
        requestPlaybackAction(playbackAction);
      }
    });
  },
  /**
   * Inform mobile app of the current state of the Picture in Picture (PiP) mode
   * @param {boolean} isPiPActive - Whether PiP is active or not
   */
  pipStatus(isPiPActive) {
    // IOS
    const iosBridge = this.getIosBridge();
    if (iosBridge) {
      try {
        iosBridge.messageHandlers.pipStatus.postMessage(isPiPActive);
        return 'ios';
      } catch (e) {
        return e;
      }
    }
    return null;
  },
};

export default MobileApi;
